"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityNetwork = exports.EntityNetworkClassName = void 0;
const ModelCommon_1 = require("./ModelCommon");
exports.EntityNetworkClassName = 'EntityNetwork';
class EntityNetwork extends ModelCommon_1.ModelCommon {
    constructor({ domain, ...ob }) {
        if (ob.type !== undefined && ob.type !== exports.EntityNetworkClassName)
            throw new Error(`Tried to create a ${exports.EntityNetworkClassName} from a ${ob.type} object!`);
        super(exports.EntityNetworkClassName, ob);
        this.type = ob.type ?? exports.EntityNetworkClassName;
        this.domain = domain;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.EntityNetwork = EntityNetwork;
